import React from 'react'
// libs
import styled from 'styled-components'
// views
import { ButtonsWrapper } from 'components/PageComponents/Settings/ObjectsAndProperties/Edit/Properties/components/Property/view'
// themes
import { colors } from 'themes'
// icons
import CheckedOriginIcon from '@mui/icons-material/Check'
// utils
import { size } from 'polished'

const CheckedIcon = styled(CheckedOriginIcon)`
  margin-left: 8px;
  right: 0;
`

const Header = styled.div`
  color: ${colors.blue500};
  font-size: 16px;
  font-weight: bold;
  display: flex;

  justify-content: space-between;
  align-items: center;

  flex: 1;
  border-bottom: 1px solid ${colors.blue500};
  position: relative;
  height: 32px;
`

const OptionTitle = styled('div')`
  display: flex;
  font-size: 13px;

  svg {
    ${size('14px')}
  }
`

const OptionWrapper = styled('div')<{ isActive: boolean }>`
  color: ${({ isActive }) => (isActive ? colors.gray850 : colors.gray300)};
  cursor: pointer;
  font-size: 11px;
  padding: 0 8px;
  max-width: 354px;
  margin-bottom: 12px;
  position: relative;

  ${ButtonsWrapper} {
    height: 20px;
    display: none;

    svg {
      height: 12px !important;
      width: 12px !important;
    }
  }

  &:hover {
    ${ButtonsWrapper} {
      display: flex;
    }
  }

  p {
    margin: 0;
  }

  svg:first-child {
    margin-right: 4px;
  }

  svg {
    ${size('16px')}
  }
`

const Wrapper = styled('div')`
  padding: 8px;
  width: 370px;
  min-height: 94px;
  max-height: calc(100vh - 100px);

  > div:first-child {
    font-size: 13px;
    justify-content: center;
    margin-bottom: 16px;
  }

  .MuiFormLabel-root {
    font-size: 17px;
  }
`

const ButtonContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  color: ${colors.blue500};
  cursor: pointer;
  font-size: 14px;
`

export { CheckedIcon, Header, OptionTitle, OptionWrapper, Wrapper, ButtonContainer }
